var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.25,
    stroke: "#FF6019",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4062 10.2031L17.1162 19.0889H15.0068L14.708 10.2031H17.4062ZM14.6377 21.8398C14.6377 21.4648 14.7666 21.1543 15.0244 20.9082C15.2881 20.6562 15.6338 20.5303 16.0615 20.5303C16.4951 20.5303 16.8408 20.6562 17.0986 20.9082C17.3564 21.1543 17.4854 21.4648 17.4854 21.8398C17.4854 22.2031 17.3564 22.5107 17.0986 22.7627C16.8408 23.0146 16.4951 23.1406 16.0615 23.1406C15.6338 23.1406 15.2881 23.0146 15.0244 22.7627C14.7666 22.5107 14.6377 22.2031 14.6377 21.8398Z",
    fill: "#FF6019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.2c620356.svg";
export { ForwardRef as ReactComponent };